var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8365 6.97952C23.8844 6.80364 23.01 7.41122 22.8288 8.34058C22.6475 9.26995 23.257 10.1773 24.1832 10.3592C26.9717 10.9028 29.1249 13.0613 29.6706 15.8594V15.8614C29.826 16.6669 30.5351 17.2525 31.3517 17.2525C31.4613 17.2525 31.5708 17.2425 31.6824 17.2225C32.6085 17.0366 33.218 16.1312 33.0368 15.1999C32.2221 11.0207 29.0054 7.79296 24.8365 6.97952Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7117 0.0158595C24.2655 -0.0480965 23.8174 0.0838129 23.4608 0.367618C23.0944 0.65542 22.8653 1.07113 22.8155 1.53682C22.7099 2.47817 23.3891 3.32958 24.3293 3.43551C30.8126 4.15901 35.8519 9.20955 36.5809 15.7131C36.6785 16.5845 37.4094 17.242 38.2819 17.242C38.3476 17.242 38.4113 17.238 38.4771 17.23C38.9332 17.1801 39.3395 16.9542 39.6263 16.5945C39.9112 16.2347 40.0406 15.787 39.9888 15.3293C39.0806 7.21492 32.8004 0.91724 24.7117 0.0158595Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0635 21.9448C26.0416 29.9207 27.8515 20.6934 32.9313 25.7696C37.8286 30.6655 40.6432 31.6464 34.4385 37.8494C33.6613 38.474 28.7232 45.9885 11.3692 28.6393C-5.98696 11.288 1.52317 6.34489 2.14794 5.5679C8.36773 -0.652308 9.33173 2.17877 14.229 7.07466C19.3087 12.153 10.0853 13.9688 18.0635 21.9448Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.fc721003.svg";
export { ForwardRef as ReactComponent };